import { SelectInput } from '@frontend/basic-forms';
import React from 'react';
import { ActionMeta } from 'react-select';

import useWorkflowStepTriggerSelect from './workflow-step-trigger-select.controller';

const ID = 'workflow-step-trigger-select';
export interface WorkflowStepTriggerSelectProps {
    required: boolean;
    submitted: boolean;
    onChange: (newValue: { value: string; label: any }, actionMeta: ActionMeta<any>) => void;
    value?: string;
}

export const WorkflowStepTriggerSelect = (props: WorkflowStepTriggerSelectProps) => {
    const viewProps = useWorkflowStepTriggerSelect();

    return (
        <div id={ID}>
            <SelectInput
                label={'Trigger'}
                submitted={props.submitted}
                required={props.required}
                options={viewProps.options}
                value={props.value}
                onChange={(value, actionMeta) => props.onChange(value as { value: string; label: any }, actionMeta)}
            />
        </div>
    );
};
